import React, { useContext } from 'react';
import { getTranslation } from '../../utils/config';
import { escapeRegExp } from '../../utils/escape';
import { Accordion, AccordionContext, useAccordionButton } from 'react-bootstrap';

interface CustomHeaderProps {
  children: React.ReactNode;
  eventKey: string;
}

function CustomHeader({ children, eventKey }: CustomHeaderProps) {
  const { activeEventKey } = useContext(AccordionContext);
  const decoratedOnClick = useAccordionButton(eventKey);

  return (
    <button
      className="df-show-hide-details__button"
      type="button"
      onClick={decoratedOnClick}
      aria-expanded={activeEventKey === eventKey}
    >
      {children}
    </button>
  );
}

export interface CardTextSearchProps {
  taggingProduct: Array<string>;
  groupId?: number;
  expandInitially?: boolean;
}

export default function CardTextSearch({
  taggingProduct,
  groupId,
  expandInitially = false,
}: CardTextSearchProps): React.ReactElement {
  const [text, setText] = React.useState<Array<string>>([]);

  const markKeyWord = (e: React.FormEvent<HTMLInputElement>) => {
    const markedChars = escapeRegExp(e.currentTarget.value);
    let textSearch = taggingProduct;

    if (markedChars) {
      const keyWord = markedChars.toLowerCase();

      let markedTags = taggingProduct.filter((tag) => tag.toLowerCase().includes(keyWord));
      const unmarkedTags = taggingProduct.filter((tag) => !tag.toLowerCase().includes(keyWord));

      // replace case insensitive
      const regEx = new RegExp(keyWord, 'i');

      markedTags = markedTags.map((tag, index) =>
        index > 0
          ? ` ${tag.replace(regEx, '<mark>$&</mark>')}`
          : tag.replace(regEx, '<mark>$&</mark>'),
      );

      textSearch = [...markedTags, ...unmarkedTags];
    }

    setText(textSearch);
  };

  React.useEffect(() => {
    setText(taggingProduct.map((tag, index) => (index > 0 ? ` ${tag}` : tag)));
  }, [taggingProduct]);

  const eventKey = `df-download-fitting-products-${groupId}`;
  return (
    <Accordion defaultActiveKey={expandInitially ? eventKey : undefined} flush>
      <Accordion.Item className="df-show-hide-details" eventKey={eventKey}>
        <CustomHeader eventKey={eventKey}>{getTranslation('textsearch_title')}</CustomHeader>
        <Accordion.Body>
          {taggingProduct.length > 5 && (
            <div className="df-text-search">
              <form onSubmit={(e) => e.preventDefault()}>
                <label>
                  <span className="hidden">{getTranslation('textsearch_searchlist')}</span>
                  <input
                    type="search"
                    name="df-text-search__keyword"
                    className="df-text-search__keyword"
                    placeholder={getTranslation('textsearch_searchlist')}
                    onChange={(e) => markKeyWord(e)}
                  />
                </label>
              </form>
            </div>
          )}
          <div className="df-text df-text-full-width">
            <p dangerouslySetInnerHTML={{ __html: text.join(', ') }} />
          </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
}
